<template>
    <div class="we-logo" :class="{ 'searching': searching, 'small': small }">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 820.8 96.8" style="enable-background:new 0 0 820.8 96.8;" xml:space="preserve">
            <g>
                <path class="stw" d="M106.9,32.3l8.4,21.5l8.8-23.1l8.4,23.1l8.8-21.5h5.3l-14.4,34.2l-8.3-22.8l-8.6,22.8l-13.7-34.2H106.9z"/>
                <path class="stw" d="M192.4,56.7h-13.8l-3.6,7.8h-5.2l15.9-34.2l15.4,34.2h-5.3L192.4,56.7z M190.4,52.1l-4.8-10.9l-5,10.9H190.4z"
                    />
                <path class="stw" d="M237.8,36.9v27.6h-4.9V36.9h-7.4v-4.6h19.6v4.6H237.8z"/>
                <path class="stw" d="M297.7,34.1v5.8c-2.8-2.3-5.7-3.5-8.7-3.5c-3.3,0-6.1,1.2-8.4,3.6s-3.4,5.3-3.4,8.7s1.1,6.2,3.4,8.5
                    c2.3,2.3,5.1,3.5,8.4,3.5c1.7,0,3.2-0.3,4.4-0.8c0.7-0.3,1.4-0.7,2.1-1.1c0.7-0.5,1.5-1,2.3-1.7V63c-2.8,1.6-5.7,2.4-8.8,2.4
                    c-4.6,0-8.5-1.6-11.8-4.8c-3.2-3.2-4.9-7.1-4.9-11.7c0-4.1,1.4-7.8,4.1-11c3.3-3.9,7.7-5.9,12.9-5.9
                    C292.2,31.7,295,32.5,297.7,34.1z"/>
                <path class="stw" d="M335.2,44.9h13.9V32.3h4.9v32.2h-4.9v-15h-13.9v15h-4.9V32.3h4.9V44.9z"/>
                <path class="stw" d="M403.4,36.9h-11.2v7.7H403v4.6h-10.8v15.3h-4.9V32.3h16.1V36.9z"/>
                <path class="stw" d="M439.5,32.3v19.4c0,2.8,0.5,4.8,1.4,6.1c1.3,1.8,3.2,2.8,5.7,2.8s4.4-0.9,5.7-2.8c0.9-1.2,1.4-3.3,1.4-6.1
                    V32.3h4.9V53c0,3.4-1.1,6.2-3.2,8.4c-2.4,2.4-5.3,3.7-8.8,3.7s-6.4-1.2-8.7-3.7c-2.1-2.2-3.2-5-3.2-8.4V32.3H439.5z"/>
                <path class="stw" d="M496.6,32.3v27.6h9.5v4.6h-14.3V32.3H496.6z"/>
                <path class="stw" d="M613.9,36.9H601v7.7h12.5v4.6H601V60h12.9v4.6h-17.8V32.3h17.8V36.9z"/>
                <path class="stw" d="M652.4,50.6l-10.6-18.3h5.6l7.4,12.9l7.4-12.9h5.6l-10.5,18.3v13.9h-4.9L652.4,50.6L652.4,50.6z"/>
                <path class="stw" d="M714.8,36.9h-12.9v7.7h12.5v4.6h-12.5V60h12.9v4.6H697V32.3h17.8V36.9z"/>
            </g>
            <circle style="animation-delay: 0.1s" class="st0" cx="158.9" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.2s" class="st0" cx="213.6" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.3s" class="st0" cx="259.5" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.4s" class="st0" cx="313.2" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.5s" class="st0" cx="371.1" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.6s" class="st0" cx="419.2" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.7s" class="st0" cx="473.7" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.8s" class="st0" cx="633.2" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.9s" class="st0" cx="680.2" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.10s" class="st0" cx="91.1" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.11s" class="st1" cx="68.9" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.12s" class="st2" cx="46.7" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.13s" class="st3" cx="24.6" cy="48.7" r="2.9"/>
            <circle style="animation-delay: 0.14s" class="st0" cx="730" cy="48.4" r="2.9"/>
            <circle style="animation-delay: 0.15s" class="st1" cx="752.1" cy="48.4" r="2.9"/>
            <circle style="animation-delay: 0.16s" class="st2" cx="774.3" cy="48.4" r="2.9"/>
            <circle style="animation-delay: 0.17s" class="st3" cx="796.5" cy="48.4" r="2.9"/>
            <g id="YLbqva.tif">
                <g>
                    <path class="st0" d="M549.4,62.7c-0.4,0-1.1,0-1.7-0.2c-0.7-0.1-1.3-0.3-2-0.5c-0.4-0.1-0.9-0.3-1.3-0.4c-0.5-0.2-1.1-0.5-1.6-0.8
                        c-0.4-0.2-0.8-0.4-1.1-0.7c-0.6-0.4-1.3-0.9-1.9-1.3c-0.7-0.5-1.4-1.1-2-1.7c-0.4-0.4-0.8-0.8-1.2-1.2c-0.4-0.4-0.7-0.7-1.1-1.1
                        c-0.6-0.6-1.1-1.3-1.6-1.9c-0.4-0.5-0.8-0.9-1.1-1.4c-0.4-0.5-0.8-1.1-1.1-1.6c-0.3-0.4-0.5-0.8-0.8-1.2c-0.2-0.3-0.2-0.5,0-0.8
                        c0.5-0.7,1-1.4,1.4-2.1c0.4-0.5,0.8-1.1,1.2-1.6c0.6-0.7,1.1-1.4,1.7-2c0.6-0.6,1.2-1.2,1.8-1.8c0.9-0.8,1.9-1.7,2.9-2.5
                        c0.5-0.4,1.1-0.8,1.7-1.2c0.7-0.4,1.5-0.8,2.2-1.2c0.3-0.2,0.7-0.3,1.1-0.4c0.5-0.2,1.1-0.4,1.6-0.5c0.6-0.1,1.2-0.2,1.8-0.3
                        c1.1-0.2,2.2-0.1,3.3,0.1c0.7,0.1,1.4,0.3,2.1,0.5c0.4,0.1,0.9,0.3,1.3,0.4c0.3,0.1,0.7,0.3,1,0.5c0.5,0.3,1,0.5,1.4,0.8
                        c0.4,0.2,0.8,0.5,1.2,0.8c0.4,0.3,0.8,0.6,1.2,0.9c0.6,0.5,1.1,1,1.7,1.5c0.4,0.4,0.8,0.7,1.2,1.1c0.6,0.6,1.1,1.2,1.7,1.8
                        c0.4,0.4,0.7,0.8,1,1.2c0.4,0.5,0.9,1.1,1.3,1.7c0.6,0.8,1.2,1.7,1.8,2.5c0.1,0.2,0.1,0.4,0,0.7c-0.6,0.9-1.2,1.7-1.8,2.6
                        c-0.4,0.5-0.7,1-1.1,1.5c-0.6,0.7-1.2,1.4-1.9,2.1c-0.6,0.6-1.1,1.2-1.7,1.8c-0.4,0.4-0.9,0.9-1.4,1.2c-0.7,0.5-1.3,1.1-2,1.6
                        c-0.5,0.4-1.1,0.8-1.7,1.1c-0.5,0.3-1.1,0.6-1.6,0.8c-0.6,0.3-1.2,0.5-1.9,0.7c-0.3,0.1-0.5,0.2-0.8,0.2
                        C551.7,62.6,550.7,62.7,549.4,62.7z M559.2,48.4c0.1-5.3-4.3-9.5-9.5-9.6c-5.3,0-9.6,4.2-9.6,9.5c0,5.4,4.3,9.6,9.4,9.7
                        C554.8,58.1,559.2,53.8,559.2,48.4z"/>
                    <path class="st0" d="M549.7,53.2c-2.5,0.1-4.8-2.1-4.8-4.8c0-2.6,2.2-4.7,4.8-4.7c2.5,0,4.7,2.1,4.7,4.8
                        C554.4,51.1,552.2,53.3,549.7,53.2z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'WELogo',
    props: {
        searching: Boolean,
        small: Boolean,
    },
}
</script>

<style lang="scss" scoped>
@import '../styles/palette';

@keyframes blink {
    from {
        opacity: 0.2;
    }
    to {
        opacity: 0.8;
    }
}

.we-logo {
    svg {
        width: 100%;
    }

    &.searching {
        circle {
            animation: blink 1s infinite;
        }
    }

    &.small {
        width: 30rem;
    }
}
.st0{fill:$yellow;}
.st1{opacity:0.75;fill:$yellow;}
.st2{opacity:0.5;fill:$yellow;}
.st3{opacity:0.25;fill:$yellow;}
.stw{fill: white;}
</style>